<template>
  <div id="app">
    <SnackbarComponent :value="snackbarData"/>
    <router-view></router-view>
  </div>
</template>

<script>

import SnackbarComponent from '@/components/Snackbar'

export default {
  name: 'App',
  components: {
    SnackbarComponent,
  },
  data() {
    return {
      snackbarData: {
        openSnackbar: false,
        description: ''
      }
    };
  },
}
</script>

<style>
  /* Aplica a la mayoría de los navegadores */
  input[type="number"] {
      -moz-appearance: textfield;
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
  }

  /* Aplica a navegadores basados en WebKit */
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  input[type="number"] {
      -moz-appearance: textfield;
  }

  .red {
    color: red;
    font-weight: 800;
    text-decoration: underline;
  }
  .green {
    color: #2fdd7a;
    font-weight: 800;
    text-decoration: underline;
  }
  .gray {
    color: gray;
    font-weight: 800;
    text-decoration: underline;
  }

</style>
